module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0126.jpg?v=2790f2fe";